import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import endpoints from "../../endpoint";
import axios from "axios";

// async thunk for  fetching the course videos by coursID
export const addWebinar = createAsyncThunk(
  "strategy/addWebinar",
  async ({ WebinarData, onSuccess }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("token");

    try {
      const webinarPayload = {
        title: WebinarData.title,
        description: WebinarData.description,
        videoId: WebinarData.videoId,
        date: WebinarData.date,
      };

      const response = await axios.post(
        `${endpoints.serverBaseUrl}api/webinar`,
        webinarPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (onSuccess) onSuccess();

      return response.data;
    } catch (error) {
      console.error("Error adding webinar:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while adding the webinar."
      );
    }
  }
);

export const fetchWebinar = createAsyncThunk(
  "strategy/fetchWebinar",
  async (_, { rejectWithValue }) => {
    const token = sessionStorage.getItem("token");
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/webinar`,
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching strategies:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching strategies."
      );
    }
  }
);

export const UpdateWebinar = createAsyncThunk(
  "strategy/updateWebinar",
  async ({ WebinarData, onSuccess }, { rejectWithValue }) => {
    const token = sessionStorage.getItem("token");
    try {
      const webinarPayload = {
        title: WebinarData.title,
        description: WebinarData.description,
        videoId: WebinarData.videoId,
        status: WebinarData.status,
        liveDate: WebinarData.liveDate,
      };

      const response = await axios.put(
        `${endpoints.serverBaseUrl}api/webinar/${WebinarData?.strategyId}`,
        webinarPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (onSuccess) onSuccess();

      return response.data;
    } catch (error) {
      console.error("Error updating webinar:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while updating the webinar."
      );
    }
  }
);

const WebinarSlice = createSlice({
  name: "Webinar",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addWebinar.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addWebinar.fulfilled, (state, action) => {
        state.loading = false;
      })
      //fetch stragies
      .addCase(addWebinar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchWebinar.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebinar.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWebinar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = WebinarSlice.actions;
export default WebinarSlice.reducer;
